import React, { Component } from 'react';
import axios from 'axios';
import TableRow from './TableRow';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import AssignmentIcon from '@material-ui/icons/Assignment';
import Fab from '@material-ui/core/Fab';
import EmisorIcon from '@material-ui/icons/AccountBoxRounded';
import SearchIcon from '@material-ui/icons/SearchRounded';

import TipoIcon from '@material-ui/icons/BookRounded';
import FechaIcon from '@material-ui/icons/EventRounded';
import Grid from '@material-ui/core/Grid';
import { makeStyles,styled } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import { DropdownList } from 'react-widgets';
import Card from 'react-bootstrap/Card';
import { Document, Page, Text, View, StyleSheet,Font , PDFViewer, PDFDownloadLink,Image} from "@react-pdf/renderer";

import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import ExplicitIcon from '@material-ui/icons/Explicit';
import DescriptionIcon from '@material-ui/icons/Description';

import NoteAddIcon from '@material-ui/icons/NoteAdd';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import NavigationIcon from '@material-ui/icons/Navigation';
import {Modal,Table} from 'react-bootstrap'
import { reporte, reporteLic,reporteArea,reporteAreaE,reporteAreasEstatus,GetGiro, GetCTRep, POSTNoregistro, GetCTRepCM, GetCTRepNR} from '../../services/SecurityService';
import clsx from 'clsx';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import PageviewIcon from '@material-ui/icons/Pageview';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import {
  ExcelExport,
  ExcelExportColumn,
  ExcelExportColumnGroup,
} from "@progress/kendo-react-excel-export";
import ReactExport from "react-export-excel";
import styles2 from './VentanaPrincipal.css'
import InputAdornment from '@material-ui/core/InputAdornment';
import CardUserPhoto from './CardUserPhoto';
import { ContactSupportOutlined, TransferWithinAStation } from '@material-ui/icons';
import Pagination from 'react-js-pagination';
import styles3 from './Pagination.css'

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const useStyles = makeStyles(theme => ({
  fab: {
    margin: theme.spacing(1),
  },
  extendedIcon: {
    marginRight: theme.spacing(1),
  },
}));

const ColorButton = styled(Button)(({ theme }) => ({
  color: '#a02142',
  borderColor: '#a02142',
  '&:hover': {
    backgroundColor: '#a02142',
    color:'#ffffff'
  },
}));

const ColorButtonLic = styled(Button)(({ theme }) => ({
  color: '#274178',
  borderColor: '#274178',
  '&:hover': {
    backgroundColor: '#274178',
    color:'#ffffff'
  },
}));

const ColorButton2 = styled(Button)(({ theme }) => ({
  color: '#3cba54',
  borderColor: '#3cba54',
  '&:hover': {
    backgroundColor: '#3cba54',
    color:'#ffffff'
  },
}));

const data = [
  {
    matricula: '123456',
    clase: 'A',
    estatus: 'Activo',
    nombre: 'Juan',
    ap_materno: 'Gómez',
    ap_paterno: 'Pérez',
    domicilio: 'Calle 123',
    estado_civil: 'Soltero',
    fecha_nac: '1990-01-01',
    CURP: 'ABCDEFGHIJK123456',
    leer_escribir: 'Sí',
    lugar_nac: 'Ciudad de México',
    ocupacion: 'Ingeniero',
    remiso: 'No',
    FechaValidado: '2023-11-30'
  }
];

export default class VentanaPrincipal extends Component {
  
  

  constructor(props) {
      super(props);
      console.log("PPROPS")
      console.log(this.props)
      console.log(props)


      this.onChangenombre = this.onChangenombre.bind(this);
      this.onChangeapellidopaterno = this.onChangeapellidopaterno.bind(this);
      this.onChangeapellidomaterno = this.onChangeapellidomaterno.bind(this);
      this.onChangecurp = this.onChangecurp.bind(this);
      this.onChangeclase = this.onChangeclase.bind(this);
      this.onChangetelefono = this.onChangetelefono.bind(this);
      this.onChangedomicilio = this.onChangedomicilio.bind(this);
      this.onChangefechareg = this.onChangefechareg.bind(this);






      this.handleShow = this.handleShow.bind(this);

      this.handleShow2 = this.handleShow2.bind(this);
      this.handleClose2 = this.handleClose2.bind(this);

      this.handleShow3 = this.handleShow3.bind(this);
      this.handleClose3 = this.handleClose3.bind(this);

      this.onChangeGiro = this.onChangeGiro.bind(this);
      this.handleShow22 = this.handleShow22.bind(this);
      this.handleClose22 = this.handleClose22.bind(this);
      this.handleShow2g = this.handleShow2g.bind(this);
      this.handleClose2g = this.handleClose2g.bind(this);

      this.handleShow23 = this.handleShow23.bind(this);
      this.handleClose23 = this.handleClose23.bind(this);
      this.handleShow23a = this.handleShow23a.bind(this);
      this.handleClose23a = this.handleClose23a.bind(this);

      this.handleShow24 = this.handleShow24.bind(this);
      this.handleClose24 = this.handleClose24.bind(this);

      this.onChangeBuscar = this.onChangeBuscar.bind(this);
      this.onChangeBuscar2 = this.onChangeBuscar2.bind(this);

      this.onChangeFechaFinal = this.onChangeFechaFinal.bind(this);
      this.onChangeFechaInicial = this.onChangeFechaInicial.bind(this);
      this.generarreporte=this.generarreporte.bind(this);
      this.generarreporte22=this.generarreporte22.bind(this);
      this.generarreporte222=this.generarreporte222.bind(this);

      this.generarreportelic=this.generarreportelic.bind(this);
      this.generarreporteArea=this.generarreporteArea.bind(this);
      this.generarreporteEstatus=this.generarreporteEstatus.bind(this);
      this.pdf = this.pdf.bind(this);
      this.pdf22 = this.pdf22.bind(this);
      this.pdf222 = this.pdf222.bind(this);

      this.handlePageChange = this.handlePageChange.bind(this);
      this.pag = this.pag.bind(this);

      let datea = new Date().getDate();
      let month = new Date().getMonth() + 1;
      let year = new Date().getFullYear();

if(month<10){month="0"+month;}
if(datea<10){datea="0"+datea;}
      let fechaRR =year+'-'+month+'-'+datea;

      this.state = {
        buscar : '',
        buscar2 : '',
        activado:false,
        activado2:false,
        activado22:false,
        activado222:false,
        activado3:false,
        activado4:false,
        area:451,
        est:5,
        FechaFinal:fechaRR,
        FechaInicial:'2025-01-01',
        excel:[],
        excel22:[],
        excel222:[],
        show:false,
        show2:false,
        show2g:false,
        show2g22:false,
        show2g222:false,
        show22:false,
        show23:false,
        show23a:false,
        show24:false,
        show222:false,
        show223:false,
        show224:false,
        bus : false,
        bs : [],
        civil:10,
        curbanistica:10,
        san:10,
        ecol:10,
        aplicar:0,
        oficiosR: this.props.oficiosEP,
        oficiosEP: this.props.oficiosEP,
        indice:this.props.indice,
        vacio : [{no_folio:"",emisor:"",Tipo:"",asunto:"",fecha_documento:"",fecha_documento:"",fecha_termino:"",
        usuarioSeguimiento:""}],

        giro_riesgo:'',
        aplicar_fecha:0,
        Giro:[],
        value3:{NO:0,'IDENTIFICACION DE GIRO':0,GIRO:'TODOS LOS GIROS'},
        idG:0,
        GirosFiltrado:this.props.obj,
        generarExcel:false,

        OEP:0,
        OT:0,

        activePage: 1,

        ap_paterno:'',
        ap_materno:'',
        nombre:'',
        CURP:'',
        clase:'',
        domicilio:'',
        telefono:'',
        fecha_reg:'',
      };


    }

    handlePageChange(pageNumber) {
      this.setState({ activePage: pageNumber });
    }

    onChangeGiro(GIRO) {
      console.log(GIRO);
  
    let { Giro} = this.state;
    
    let newOption = GIRO
    this.setState({
      value3: newOption,  
      idG:newOption.NO,
      Giro: [...Giro],
      buscar:' '
    
    })
    }

    onChangenombre(e) {
      this.setState({
      nombre : e.target.value
      });
      }
      
      onChangeapellidopaterno(e) {
        this.setState({
        ap_paterno : e.target.value
        });
        }

        onChangeapellidomaterno(e) {
          this.setState({
          ap_materno : e.target.value
          });
          }

          onChangecurp(e) {
            this.setState({
            CURP : e.target.value
            });
            }


            onChangeclase(e) {
              const value = e.target.value.toUpperCase();
            
              // Limitar a 4 caracteres
              if (value.length <= 4) {
                this.setState({
                  clase: value,
                });
              }
            }
  


              onChangedomicilio(e) {
                this.setState({
                domicilio : e.target.value
                });
                }

                onChangetelefono(e) {
                  this.setState({
                  telefono : e.target.value
                  });
                  }

                  onChangefechareg(e) {
                    this.setState({
                     fecha_reg : e.target.value
                    });
                    }


    onChangeBuscar(e){

      this.setState({
        buscar: e.target.value.toUpperCase()
      })
    }
    onChangeBuscar2(e){

      this.setState({
        buscar2: e.target.value.toUpperCase()
      })
    }
    componentDidMount(){
      console.log("Aqui se imprimien los OficiosR y EP y usuario logueado")
      console.log(this.props)
      console.log(this.props.id_usuario)
      console.log(this.state.oficiosR)
      console.log(this.state.oficiosEP)
      this.setState({
       
      oficiosR : this.props.oficiosR,
      indice:this.props.indice,
      bus : true
      }); 
   
      console.log("--asdadas---------->>>>>>>>>>>>><INDEX");
      console.log(this.props.indice);


   
     
    }
    tabRow(){
 let ad = this.props.id_usuario;
 let adu = this.props.id_usuariou;

 let ind=this.props.indice;

 let idusr=this.props.iduser;

 let colorb;
 let pes;
 let apl=this.state.aplicar;
 let onR=this.props.onR;
let tp=this.props.tipo;
if(tp==1){
 if(ind==0){
  colorb='info'
  pes='Preregistros'
}else if(ind==1){
  colorb='primary'
 pes='Registrados'
}else if(ind==2){
 colorb='secondary'
 pes='Pendiente'
}else if(ind==3){
  colorb='warning'
 pes='En tramite'
}else if(ind==4){
 colorb='secondary'
 pes='En firmas'
}else if(ind==5){
 colorb='primary'
 pes='Por Entregar'
}else if(ind==6){
  colorb='success'
  pes='Positivos'
}
}else{
  if(ind==0){
    colorb='info'
    pes='Preregistros'
  }else if(ind==1){
    colorb='secondary'
   pes='En firmas'
  }

}
      if(this.state.bus==false || this.state.buscar==""){

      if(this.props.oficiosR==null || this.props.oficiosR==="" || this.props.oficiosR=="OK" || this.props.oficiosR.fatal==false){
        return <tr style={{textAlign:'center' }} ><td > Sin registros</td></tr >
      }
    
      else{
      return this.props.oficiosR.map(function(object, i){
          return <TableRow obj={object} key={i} user={ad} index={ind} iduser={idusr}  botoncolor={colorb}  onR={onR} tipo={tp} id_usuario={adu}/>;
      });


    }

  } else if (this.state.bus==true){

    if(this.state.bs==null || this.state.bs==="" || this.state.bs=="OK" ){
      return console.log("NO hay oficios");
    }
    else{
    let f =this.props.oficiosR;
    let userL =this.props.id_usuario;
    let userL2 =this.props.id_usuariou;

    let ind=this.props.indice;
    let idusrr=this.props.iduser;

    let onR=this.props.onR;

    let colorb;
let apli=this.state.aplicar;
let grg=this.state.giro_riesgo;
let afa=this.state.aplicar_fecha;
let idGG=this.state.idG
let tpp=this.props.tipo;

if(tpp==1){ 
if(ind==0){
  colorb='info'
  
}else if(ind==1){
  colorb='primary'
 
}else if(ind==2){
 colorb='secondary'
 
}else if(ind==3){
  colorb='warning'
 
}else if(ind==4){
 colorb='secondary'
 
}else if(ind==5){
 colorb='primary'

}else if(ind==6){
  colorb='success'

}
}else{
  if(ind==0){
    colorb='info'
    pes='Preregistros'
  }else if(ind==1){
    colorb='secondary'
   pes='En firmas'
  }

}
   
    if(this.props.oficiosR!="No existen clientes en la BBDD." && this.props.oficiosR!="OK"){
     
      if(tpp==1 && ind==0)
      {    f= f.filter(d=> d.nombre.toUpperCase().includes(this.state.buscar.toUpperCase()) ||  d.ap_paterno.toUpperCase().includes(this.state.buscar.toUpperCase()))
}else{
  f= f.filter(d=> d.nombre.toUpperCase().includes(this.state.buscar.toUpperCase()) ||  d.ap_paterno.toUpperCase().includes(this.state.buscar.toUpperCase()) ||  d.matricula==this.state.buscar)
}
      

    return f.map(function(object, i){
        return <TableRow obj={object} key={i} user={userL} index={ind} iduser={idusrr} botoncolor={colorb} onR={onR} tipo={tpp} id_usuario={userL2}/>;
    });
  }
  }
  }



  
    }



    tabRow2(obj){

      console.log("AAC::::::::::");
      console.log(obj);
      let ad = this.props.id_usuario;
      let adu = this.props.id_usuariou;
     
      let ind=this.props.indice;
     
      let idusr=this.props.iduser;
     
      let colorb;
      let pes;
      let apl=this.state.aplicar;
      let onR=this.props.onR;
     let tp=this.props.tipo;
     if(tp==1){
      if(ind==0){
       colorb='info'
       pes='Preregistros'
     }else if(ind==1){
       colorb='primary'
      pes='Registrados'
     }else if(ind==2){
      colorb='secondary'
      pes='Pendiente'
     }else if(ind==3){
       colorb='warning'
      pes='En tramite'
     }else if(ind==4){
      colorb='secondary'
      pes='En firmas'
     }else if(ind==5){
      colorb='primary'
      pes='Por Entregar'
     }else if(ind==6){
       colorb='success'
       pes='Positivos'
     }
     }else{
       if(ind==0){
         colorb='info'
         pes='Preregistros'
       }else if(ind==1){
         colorb='secondary'
        pes='En firmas'
       }
     
     }
           if(this.state.bus==false || this.state.buscar==""){
     
           if(obj==null || obj==="" || obj=="OK" || obj.fatal==false || obj==[] || obj==''){
             return <tr style={{textAlign:'center' }} ><td style={{fontWeight:'bolder'}}> Sin registros</td></tr >
           }
         
           else{
           return obj.map(function(object, i){
               return <TableRow obj={object} key={i} user={ad} index={ind} iduser={idusr}  botoncolor={colorb}  onR={onR} tipo={tp} id_usuario={adu}/>;
           });
     
     
         }
     
       } else if (this.state.bus==true){
     
         if(this.state.bs==null || this.state.bs==="" || this.state.bs=="OK" ){
           return console.log("NO hay oficios");
         }
         else{
         let f =obj;
         let f2 = this.props.oficiosR;
         let userL =this.props.id_usuario;
         let userL2 =this.props.id_usuariou;
     
         let ind=this.props.indice;
         let idusrr=this.props.iduser;
     
         let onR=this.props.onR;
     
         let colorb;
     let apli=this.state.aplicar;
     let grg=this.state.giro_riesgo;
     let afa=this.state.aplicar_fecha;
     let idGG=this.state.idG
     let tpp=this.props.tipo;
     
     if(tpp==1){ 
     if(ind==0){
       colorb='info'
       
     }else if(ind==1){
       colorb='primary'
      
     }else if(ind==2){
      colorb='secondary'
      
     }else if(ind==3){
       colorb='warning'
      
     }else if(ind==4){
      colorb='secondary'
      
     }else if(ind==5){
      colorb='primary'
     
     }else if(ind==6){
       colorb='success'
     
     }
     }else{
       if(ind==0){
         colorb='info'
         pes='Preregistros'
       }else if(ind==1){
         colorb='secondary'
        pes='En firmas'
       }
     
     }
        
         if(obj!="No existen clientes en la BBDD." && obj!="OK"){
          
           if(tpp==1 && ind==0)
           {    f= f2.filter(d=>  (d.Nomb!=undefined ? d.Nomb+"" : "").toUpperCase().includes(this.state.buscar.toUpperCase()))
     }else if(tpp==2 && ind==0){
       f= f2.filter(d=> (d.Nomb!=undefined ? d.Nomb+"" : "").toUpperCase().includes(this.state.buscar.toUpperCase()) ||   (d.matricula!=undefined ? d.matricula+"" : "").includes(this.state.buscar))
     }else if(tpp==1 && (ind==6 || ind==7)){
      f= f2.filter(d=> (d.Nomb!=undefined ? d.Nomb+"" : "").toUpperCase().includes(this.state.buscar.toUpperCase()) ||    (d.matricula!=undefined ? d.matricula+"" : "").includes(this.state.buscar))
    }else{
      f= f2.filter(d=> (d.Nomb!=undefined ? d.Nomb+"" : "").toUpperCase().includes(this.state.buscar.toUpperCase()) ||   (d.matricula!=undefined ? d.matricula+"" : "").includes(this.state.buscar))
    }
           
     
         return f.map(function(object, i){
             return <TableRow obj={object} key={i} user={userL} index={ind} iduser={idusrr} botoncolor={colorb} onR={onR} tipo={tpp} id_usuario={userL2}/>;
         });
       }
       }
       }
     
     
     
       
         }

    handleShow() {
     
     console.log("buscar")
     console.log(this.state.buscar)
     console.log(this.state.oficiosR)
     this.setState({
       
      bus : true
      }); 
    }


    handleClose2() {
      this.setState({ show: false });
    }
  
    handleShow2() {
      this.setState({ show: true });
     
    }

    handleClose3() {
      this.setState({ show3: false });
    }
  
    handleShow3() {
      this.setState({ show: true });
     
    }

    handleClose2g() {
      this.setState({ show2g: false });
    }
  
    handleShow2g() {
      this.setState({ show2g: true });
     
    }

    handleClose22() {
      this.setState({ show22: false });
    }
  
    handleShow22() {
      this.setState({ show22: true });
     
    }


    
    handleClose23() {
      this.setState({ show23: false });
    }
  
    handleShow23() {
      this.setState({ show23: true });
     
    }

    handleClose23a() {
      this.setState({ show23a: false });
    }
  
    handleShow23a() {
      this.setState({ show23a: true });
     
    }

    
    handleClose24() {
      this.setState({ show24: false });
    }
  
    handleShow24() {
      this.setState({ show24: true });
     
    }

    pdf(data){

      const fieldsToShow = [
        'matricula', 'clase', 'estatus', 'nombre', 'ap_materno',
        'ap_paterno', 'domicilio', 'estado_civil', 'fecha_nac',
        'CURP', 'leer_escribir', 'lugar_nac', 'ocupacion','nivel_estudios',
        'remiso', 'FechaValidado'
      ];
      const fieldsToShow2 = [
        'MATRICULA', 'CLASE', 'ESTATUS', 'NOMBRE', 'AP PATERNO',
        'AP MATERNO', 'DOMICILIO', 'ESTADO CIVIL', 'FECHA NAC',
        'CURP', 'LEER/ESCRIBIR', 'LUGAR NAC', 'OCUPACIÓN','ESTUDIOS',
        'REMISO', 'FECHA ENTREGA'
      ];

      return  (
        <Document>
      <Page size="A4" style={styles.page} orientation='landscape'>
        <View style={styles.section}>
          <Text style={styles.header}>DATOS PERSONAS CARTILLAS REGISTRADAS</Text>
          <View style={{ flexDirection: 'row', justifyContent: 'space-around', fontWeight: 'bold' }}>
            {/* Renderizar los encabezados de los campos */}
            {fieldsToShow2.map((field, index) => (
              <Text key={index} style={styles.cell2}>{field}</Text>
            ))}
          </View>
          {/* Iterar sobre los datos y mostrar solo los campos seleccionados */}
          {data.map((item, index) => (
            <View key={index} style={{ flexDirection: 'row', justifyContent: 'space-around' }}>
              {fieldsToShow.map((field, index) => (
                <Text key={index} style={styles.cell}>{item[field]}</Text>
              ))}
            </View>
          ))}
        </View>
      </Page>
    </Document>
    
    );
     }

     pdf222(data){

      const fieldsToShow = [
        'matricula', 'clase', 'estatus', 'nombre', 'ap_materno',
        'ap_paterno', 'domicilio', 'estado_civil', 'fecha_nac',
        'CURP', 'leer_escribir', 'lugar_nac', 'ocupacion',
        'remiso', 'fechaConstancia'
      ];
      const fieldsToShow2 = [
        'Matricula', 'Clase', 'Estatus', 'Nombre', 'Ap Paterno',
        'Ap Materno', 'Domicilio', 'ESTADO CIVIL', 'Fecha Nac',
        'CURP', 'LeerEscribir', 'Lugar Nac', 'Ocupacion',
        'Remiso', 'Fec. Constancia'
      ];

      return  (
        <Document>
      <Page size="A4" style={styles.page} orientation='landscape'>
        <View style={styles.section}>
          <Text style={styles.header}>Datos Constancias MAtriculas</Text>
          <View style={{ flexDirection: 'row', justifyContent: 'space-around', fontWeight: 'bold' }}>
            {/* Renderizar los encabezados de los campos */}
            {fieldsToShow2.map((field, index) => (
              <Text key={index} style={styles.cell2}>{field}</Text>
            ))}
          </View>
          {/* Iterar sobre los datos y mostrar solo los campos seleccionados */}
          {data.map((item, index) => (
            <View key={index} style={{ flexDirection: 'row', justifyContent: 'space-around' }}>
              {fieldsToShow.map((field, index) => (
                <Text key={index} style={styles.cell}>{item[field]}</Text>
              ))}
            </View>
          ))}
        </View>
      </Page>
    </Document>
  
    );
     }


     pdf22(data){

      const fieldsToShow = [
        'nombre', 'ap_materno',
        'ap_paterno',
        'CURP', 'clase', 'telefono', 'domicilio',
        'fecha_reg'
      ];
      const fieldsToShow2 = [
       'Nombre', 'Ap Paterno',
        'Ap Materno',
        'CURP', 'Clase', 'Telefono', 'Domicilio',
        'Fecha Registro'
      ];

      return  (
        <Document>
      <Page size="A4" style={styles.page} orientation='landscape'>
        <View style={styles.section}>
          <Text style={styles.header}>Datos No Registrados</Text>
          <View style={{ flexDirection: 'row', justifyContent: 'space-around', fontWeight: 'bold' }}>
            {/* Renderizar los encabezados de los campos */}
            {fieldsToShow2.map((field, index) => (
              <Text key={index} style={styles.cell22}>{field}</Text>
            ))}
          </View>
          {/* Iterar sobre los datos y mostrar solo los campos seleccionados */}
          {data.map((item, index) => (
            <View key={index} style={{ flexDirection: 'row', justifyContent: 'space-around' }}>
              {fieldsToShow.map((field, index) => (
                <Text key={index} style={styles.cell22g}>{item[field]}</Text>
              ))}
            </View>
          ))}
        </View>
      </Page>
    </Document>
    
    );
     }



    generarreporte(){
this.setState({
  activado:true,
  show2:false
});
      let a ={FechaFinal:this.state.FechaFinal, FechaInicial:this.state.FechaInicial}
console.log("datos")
      console.log(a);
      GetCTRep(a).then(response => {
        console.log(response);
        let exp=[];
   
if(response!='No existen clientes en la BBDD.' && response!='error en el servidor.'){
  this.setState({
        
    excel:response
    });
}
else{
  this.setState({
        
    excel:[]
    });
}

        
         console.log("r dideco")
         console.log(response)
         this.setState({show2:true,activado:false});
        }).catch(err => console.log(err)); 
    }


    
    generarreporte222(){
      this.setState({
        activado:true,
        show2:false
      });
            let a ={FechaFinal:this.state.FechaFinal, FechaInicial:this.state.FechaInicial}
      console.log("datos")
            console.log(a);
            GetCTRepCM(a).then(response => {
              console.log(response);
              let exp=[];
         
      if(response!='No existen clientes en la BBDD.' && response!='error en el servidor.'){
        this.setState({
              
          excel222:response
          });
      }
      else{
        alert('No hay registros entre las fechas seleccionadas!')
        this.setState({
              
          excel222:[]
          });
      }
      
              
               console.log("r dideco")
               console.log(response)
               this.setState({show2:true,activado:false});
              }).catch(err => console.log(err)); 
          }


          generarreporte22(){
            this.setState({
              activado:true,
              show2:false
            });
                  let a ={FechaFinal:this.state.FechaFinal, FechaInicial:this.state.FechaInicial}
            console.log("datos")
                  console.log(a);
                  GetCTRepNR(a).then(response => {
                    console.log(response);
                    let exp=[];
               
            if(response!='No existen clientes en la BBDD.' && response!='error en el servidor.'){
              this.setState({
                    
                excel22:response
                });
            }
            else{
              alert('No hay registros entre las fechas seleccionadas!')
              this.setState({
                    
                excel22:[]
                });
            }
            
                    
                     console.log("r dideco")
                     console.log(response)
                     this.setState({show2:true,activado:false});
                    }).catch(err => console.log(err)); 
                }
    
    generarreportelic(){
      this.setState({
        activado2:true,
        show222:false
      });
            let a ={FechaFinal:this.state.FechaFinal, FechaInicial:this.state.FechaInicial}
      console.log("datos")
            console.log(a);
            reporteLic(a).then(response => {
      
              let exp=[];
              response.forEach(function(element){
                let cc;
                if(element.RazonSocial==""){
                  cc=element.RazonSocial2;
                }
                else{
                  cc=element.RazonSocial;
                }
      
                let pcp="";
                let pcn="";
                if(element.P_CIVIL==5){
                  pcp="S";
                }
                else{
                  pcn="N";
                }
      
                let sp="";
                let sn="";
                if(element.SANIDAD==5){
                  sp="S";
                }
                else{
                  sn="N";
                }
      
                let ep="";
                let en="";
                if(element.ECOLOGIA==5){
                  ep="S";
                }
                else{
                  en="N";
                }
      
                let cp="";
                let cn="";
                if(element.COMP_URB==5){
                  cp="S";
                }
                else{
                  cn="N";
                }
      
                let com;
      
                if(element.Estatus==16){
                  com="Licencia";
                }
      
                let ne={Folio: element.Folio,TipoPersona:element.TipoPersona,pcp:pcp,pcn:pcn,sp:sp,sn:sn,ep:ep,en:en,cp:cp,cn:cn,RazonSocial:cc,Giro:element.giros,NombreSolicitante:element.NombreSolicitante,Comentarios:com,Email:element.Email,Celular:element.Celular,FechaHoraRegistro:element.FechaHoraRegistro,Colonia:element.Colonia,Localidad:element.Localidad,FechaHoraAsistio:element.FechaHoraAsistio,FechaLicencia:element.FechaLicencia,Calle:element.Calle,Numero:element.Numero,entreCalle:element.entreCalle}
                  exp.push(ne)
                
              })
      
      
      
              this.setState({
              
              excel:exp
              });
               console.log("r dideco")
               console.log(response)
               this.setState({show222:true,activado2:false});
              }).catch(err => console.log(err)); 
          }

          generarreporteArea(){
            this.setState({
              activado3:true,
              show223:false
            });
            let aarea=this.state.area;
            let eest=this.state.est;
                  let a ={FechaFinal:this.state.FechaFinal, FechaInicial:this.state.FechaInicial, Area:this.state.area, Est:this.state.est}
            console.log("datos")
                  console.log(a);
                  reporteAreaE(a).then(response => {
                    console.log("AQUI AA")
            console.log(response);
                    let exp=[];
                    response.forEach(function(element){
                      let aa='';
                      let ee='';
                      if(aarea==451){
                        console.log("AQUI pc")
                       aa='PROTECCION CIVIL';
                      }else if(aarea==452){
                        console.log("AQUI s")
                        aa='SANIDAD';
                      }else if(aarea==450){
                        console.log("AQUI e")
                       aa='ECOLOGIA';
                      }else if(aarea==448){
                        console.log("AQUI cu")
                       aa='COMPATIBILIDAD URBANISTICA';
                      }

                      if(eest==5){
                        console.log("AQUI pc")
                       ee='POSITIVO';
                      }else if(eest==4){
                        console.log("AQUI s")
                        ee='NEGATIVO';
                      }else if(eest==14){
                        console.log("AQUI e")
                       ee='PARA INSPECCIÓN';
                      }else if(eest==10){
                        console.log("AQUI e")
                       ee='PROCESO';
                      }
                      let cc;
                      if(element.RazonSocial==""){
                        cc=element.RazonSocial2;
                      }
                      else{
                        cc=element.RazonSocial;
                      }
            
                      let pcp="";
                      let pcn="";
                      if(element.P_CIVIL==5){
                        pcp="S";
                      }
                      else{
                        pcn="N";
                      }
            
                      let sp="";
                      let sn="";
                      if(element.SANIDAD==5){
                        sp="S";
                      }
                      else{
                        sn="N";
                      }
            
                      let ep="";
                      let en="";
                      if(element.ECOLOGIA==5){
                        ep="S";
                      }
                      else{
                        en="N";
                      }
            
                      let cp="";
                      let cn="";
                      if(element.COMP_URB==5){
                        cp="S";
                      }
                      else{
                        cn="N";
                      }
            
                      let com;
            
                      if(element.Estatus==16){
                        com="Licencia";
                      }
            
                      let ne={Area:aa,Estado:ee,Folio: element.Folio,TipoPersona:element.TipoPersona,pcp:pcp,pcn:pcn,sp:sp,sn:sn,ep:ep,en:en,cp:cp,cn:cn,RazonSocial:cc,Giro:element.giros,NombreSolicitante:element.NombreSolicitante,Comentarios:com,Email:element.Email,Celular:element.Celular,FechaHoraRegistro:element.FechaHoraRegistro,Colonia:element.Colonia,Localidad:element.Localidad,FechaHoraAsistio:element.FechaHoraAsistio,Calle:element.Calle,Numero:element.Numero,entreCalle:element.entreCalle}
                        exp.push(ne)
                      
                    })
            
            
            
                    this.setState({
                    
                    excel:exp
                    });
                     console.log("r dideco area")
                     console.log(response)
                     this.setState({show223:true,activado3:false});
                    }).catch(err => console.log(err)); 
                }

                generarreporteEstatus(){
                  this.setState({
                    activado4:true,
                    show224:false
                  });
                        let a ={FechaFinal:this.state.FechaFinal, FechaInicial:this.state.FechaInicial}
                  console.log("datos")
                        console.log(a);
                        reporteAreasEstatus(a).then(response => {
                  
                          let exp=[];
                          response.forEach(function(element){
                            let cc;
                            if(element.RazonSocial==""){
                              cc=element.RazonSocial2;
                            }
                            else{
                              cc=element.RazonSocial;
                            }
                  
                            let pcp="";
                            let pcn="";
                            if(element.P_CIVIL==5){
                              pcp="S";
                            }
                            else{
                              pcn="N";
                            }
                  
                            let sp="";
                            let sn="";
                            if(element.SANIDAD==5){
                              sp="S";
                            }
                            else{
                              sn="N";
                            }
                  
                            let ep="";
                            let en="";
                            if(element.ECOLOGIA==5){
                              ep="S";
                            }
                            else{
                              en="N";
                            }
                  
                            let cp="";
                            let cn="";
                            if(element.COMP_URB==5){
                              cp="S";
                            }
                            else{
                              cn="N";
                            }
                  
                            let com;
                  
                            if(element.Estatus==16){
                              com="Licencia";
                            }
                  
                            let ne={Area: element.area,positivo:element.positivo,negativo:element.negativo,suspendido:element.suspendido,proceso:element.proceso,total:element.total}
                              exp.push(ne)
                            
                          })
                  
                  
                  
                          this.setState({
                          
                          excel:exp
                          });
                           console.log("r dideco")
                           console.log(response)
                           this.setState({show224:true,activado4:false});
                          }).catch(err => console.log(err)); 
                      }


    onChangeFechaFinal(e) {
      this.setState({
      FechaFinal: e.target.value
      }) 

      console.log(e.target.value);
      }

      onChangeFechaInicial(e) {
        this.setState({
        FechaInicial: e.target.value
        }) 
        console.log(e.target.value);
        }


        pag(){
          this.setState({activePage:1})
        }
    render() {
      const _exporter = React.createRef();
      let obj={username : "desarrollo_economico", password:"u2yomty1gk"}
      let idc;
      let dd=this.props.indice;

      let idusr=this.props.id_usuario;

     

      const excelExport = () => {
        save(_exporter);
      };

      const save = component => {
        const options = component.current.workbookOptions();
        const rows = options.sheets[0].rows;
    
        rows.forEach(row => {
       
          if (row.type === 'data') {
            row.cells.forEach(cell => {
              if (cell.value == "S") {
                cell.background = '#1b5fe8';
              }else if (cell.value == "N") {
                cell.background = '#db1c1c';
              }
              else if (cell.value == "Licencia" || cell.value == "Con Licencia") {
                cell.background = '#279fb5';
              }
            });
    
        
          }
        });
        component.current.save(options);
      };
    
      





      let colorI;

      if(this.props.tipo==1){
      if(this.props.indice==0){
        colorI='#00A6A7';
      }else if(this.props.indice==1  ){
        colorI='#274178';
      }else if(this.props.indice==2){
        colorI='#606060';
      }else if(this.props.indice==3){
        colorI='#F3B122';
      }else if(this.props.indice==4){
        colorI='#606060';
      }
      else if(this.props.indice==5){
        colorI='#274178';
      }
      else if(this.props.indice==6){
        colorI='#44AC34';
      }
    }else{
        if(this.props.indice==0){
          colorI='#00A6A7';
        }else if(this.props.indice==1){
          colorI='#606060';
        }
      }







      const { activePage } = this.state;
      const itemsCountPerPage = 500; // Número de elementos por página
      const totalItemsCount = this.props.oficiosR.length; // Total de elementos en la lista
  
      // Calcular el índice del primer elemento en la página actual
      const indexOfFirstItem = (activePage - 1) * itemsCountPerPage;
      // Calcular el índice del último elemento en la página actual
      const indexOfLastItem = Math.min(indexOfFirstItem + itemsCountPerPage, totalItemsCount);
  
      // Obtener los elementos de la página actual
      const currentItems = this.props.oficiosR.slice(indexOfFirstItem, indexOfLastItem);


      const tableRows = this.tabRow2(currentItems);

      return (
        
        <div className={styles2} style={{}}>
{ <div align="right"></div>}


        





  
  

<div align="right">

  <h2 style={{float:'left'}}>
    {this.props.tipo==1 ? 
    this.props.indice==0 ? 'PREREGISTRADOS' : this.props.indice==1 ? "REGISTRADOS" : this.props.indice==2 ? "PENDIENTES" : this.props.indice==3 ? "EN TRAMITE" : this.props.indice==4 ? "EN FIRMAS" : this.props.indice==5 ? "POR ENTREGAR" : this.props.indice==6 ? "ENTREGADOS" : "TODOS"
    : this.props.indice==0?"Registrados":this.props.indice==1?"Para Firmas":"No Registrados"}</h2>

  {this.props.tipo==2 && this.props.indice==2 ? <Button onClick={()=>this.setState({show3:true})} style={{marginTop:20,borderRadius:'40px',fontSize:'16px',backgroundColor:'#E9ECEF'}} >
            <NoteAddIcon style={{fontSize:'27px',color:'#495057'}} />&nbsp;&nbsp;No Registro</Button>:null}&nbsp;&nbsp;
            {this.props.tipo==2 && this.props.indice!=2 ? <Button onClick={()=>this.setState({show222:true})} style={{marginTop:20,borderRadius:'40px',fontSize:'16px',backgroundColor:'#E9ECEF'}} >
            <DescriptionIcon style={{fontSize:'27px',color:'#495057'}} />&nbsp;&nbsp;Reporte C. Matriculas</Button>:null}&nbsp;&nbsp;

            {this.props.tipo==2 && this.props.indice==2 ? <Button onClick={()=>this.setState({show22:true})} style={{marginTop:20,borderRadius:'40px',fontSize:'16px',backgroundColor:'#E9ECEF'}} >
            <DescriptionIcon style={{fontSize:'27px',color:'#495057'}} />&nbsp;&nbsp;Reporte No Registro</Button>:null}&nbsp;&nbsp;


<Button onClick={()=>this.setState({show:true})} style={{marginTop:20,borderRadius:'40px',fontSize:'16px',backgroundColor:'#E9ECEF'}} >
            <DescriptionIcon style={{fontSize:'27px',color:'#495057'}} />&nbsp;&nbsp;Reporte General</Button>&nbsp;&nbsp;&nbsp;&nbsp;

  {this.props.br}{this.props.be}
  
  <br></br>

 
</div>

        {/* Se desocomodaba todo sin no le ponia algo cuando no hay boton por eso le puse eso que basicamente a las pestanas que no tiene boton se les ponga un br  */}
        {(this.props.indice==1 || this.props.indice==2 || this.props.indice==4 || this.props.indice==6)  || (this.props.tipo==2 && this.props.indice==0) ? <div><br/></div>:null}     
               {/* ------------------------------------------------------------------------------------------------------- */}
<br></br>



<div>
<Card style={{borderWidth:'1px',borderRadius:'12px'}}>


<Grid container spacing={2} alignContent='space-between' alignItems='center'>
<Grid xs={2}>

  <Card style={{marginLeft:'30px',height:'50px',marginTop:'30px',marginBottom:'15px'}}>

  <TextField

           
        id="standard-with-placeholder"
        type="search"
        placeholder="BUSCAR..."        
        value={this.state.buscar2}
        onChange={(e)=>this.setState({buscar2:e.target.value})}
        style={{marginLeft:'15px',marginRight:'15px',marginTop:'5px'}}
      
      />
</Card>
</Grid>

<Grid xs={1} style={{width:'30%'}}>
<Card style={{marginTop:'13px',marginRight:'15px',width:'50%'}}>
    <Button style={{height:'48px',backgroundColor:'#E9ECEF'}} onClick={()=>{this.setState({buscar:this.state.buscar2});
  this.props.onB(this.state.buscar2);
  }}> <SearchIcon style={{fontSize:'27px',color:'#495057'}} /></Button>
  </Card>
</Grid>


<Grid xs={9} style={{maxWidth:'74%'}}>
<Card style={{marginTop:'13px',marginRight:'20px'}}>
<CardUserPhoto
        buttons={this.props.buttons}
        onClick={this.props.onClick}
        etiquetaA={this.props.etiquetaA}
        aP={this.pag}
        index={this.props.indice}
        />
</Card>
</Grid>
</Grid>
<br></br>
</Card>

</div>     <br></br>
<Card style={{borderRadius:'12px'}}>
<div class="table-responsive" style={{borderRadius:'12px'}}>
          <Table size='md'   style={{marginLeft:'1px',marginTop:'1px',marginRight:'3px'}}>
            <thead >
              {this.props.tipo==2 && this.props.indice==2 ? <tr  style={{thead:'light',textAlign:'center'}} >
             
         
                <th  style={{color:'#495057',fontWeight:'bold',backgroundColor:'#E9ECEF'}} width="12%">APELLIDO PATERNO &nbsp;
                <EmisorIcon extendedIcon />
                </th>
                <th style={{ color:'#495057',fontWeight:'bold',backgroundColor:'#E9ECEF'}} width="12%">APELLIDO MATERNO &nbsp;
                <EmisorIcon extendedIcon />
                </th>
                
                <th style={{ color:'#495057',fontWeight:'bold',backgroundColor:'#E9ECEF'}} width="12%">Nombre &nbsp;
                <EmisorIcon extendedIcon />
                </th>
                <th style={{ color:'#495057',fontWeight:'bold',backgroundColor:'#E9ECEF'}} width="12%">CURP &nbsp;
                <FechaIcon extendedIcon />
                </th>
               
                <th style={{ color:'#495057',fontWeight:'bold',backgroundColor:'#E9ECEF'}} width="12%">Clase &nbsp;
                <EmisorIcon extendedIcon />
                </th>
                <th style={{ color:'#495057',fontWeight:'bold',backgroundColor:'#E9ECEF'}} width="12%">Telefono &nbsp;
                <EmisorIcon extendedIcon /></th>

                <th style={{ color:'#495057',fontWeight:'bold',backgroundColor:'#E9ECEF'}} width="12%">Fecha Reg &nbsp;
                <FechaIcon extendedIcon /></th>

          {/*   {dd > 1  ? [
                  <th width="22%">Dictamen</th>
                ] : null }      */}   
                 <th style={{ color:'#495057',fontWeight:'bold',backgroundColor:'#E9ECEF'}} width="8%">Acciones &nbsp;
                 </th>
              </tr> :
              
              <tr  style={{thead:'light',textAlign:'center'}} >
              {(this.props.tipo==1 && this.props.indice==7) ?<th style={{color:'#495057',fontWeight:'bold',backgroundColor:'#E9ECEF'}} width="7%">ESTATUS &nbsp;
                
                </th>:null}
               {(this.props.tipo==1 && this.props.indice!=0) || (this.props.tipo==2) ?<th style={{color:'#495057',fontWeight:'bold',backgroundColor:'#E9ECEF'}} width="7%">MATRICULA &nbsp;
               
                </th>:null}
         
                <th  style={{color:'#495057',fontWeight:'bold',backgroundColor:'#E9ECEF'}} width="12%">APELLIDO PATERNO &nbsp;
                <EmisorIcon extendedIcon />
                </th>
                <th style={{ color:'#495057',fontWeight:'bold',backgroundColor:'#E9ECEF'}} width="12%">APELLIDO MATERNO&nbsp;
                <EmisorIcon extendedIcon />
                </th>
                
                <th style={{ color:'#495057',fontWeight:'bold',backgroundColor:'#E9ECEF'}} width="12%">NOMBRE &nbsp;
                <EmisorIcon extendedIcon />
                </th>
                <th style={{ color:'#495057',fontWeight:'bold',backgroundColor:'#E9ECEF'}} width="12%">FECHA NACIMIENTO &nbsp;
                <FechaIcon extendedIcon />
                </th>
               
                <th style={{ color:'#495057',fontWeight:'bold',backgroundColor:'#E9ECEF'}} width="12%">ESTADO CIVIL &nbsp;
                <EmisorIcon extendedIcon />
                </th>
                <th style={{ color:'#495057',fontWeight:'bold',backgroundColor:'#E9ECEF'}} width="12%">OCUPACIÓN &nbsp;
                <EmisorIcon extendedIcon /></th>

                <th style={{ color:'#495057',fontWeight:'bold',backgroundColor:'#E9ECEF'}} width="12%">FECHA SOLICITUD &nbsp;
                <FechaIcon extendedIcon /></th>

          {/*   {dd > 1  ? [
                  <th width="22%">Dictamen</th>
                ] : null }      */}   
                 <th style={{ color:'#495057',fontWeight:'bold',backgroundColor:'#E9ECEF'}} width="8%">ACCIONES &nbsp;
                 </th>
              </tr>
              } 
            </thead>
            <tbody>
              {tableRows}
            </tbody>
          </Table>
         
          </div>
          <Pagination
          activePage={activePage}
          itemsCountPerPage={itemsCountPerPage}
          totalItemsCount={totalItemsCount}
          pageRangeDisplayed={5}
          onChange={this.handlePageChange.bind(this)}
          itemClass="pagination-button" // Clase CSS para los botones de paginación
          activeClass="pagination-active" // Clase CSS para la página activa
          activeLinkClass="pagination-active"
          innerClass="pagination-container" 
          linkClass="pagination-button"
        />
          </Card>
          <>


          
            
      
                <Modal 
               size="xl"
               aria-labelledby="contained-modal-title-vcenter"
               dialogClassName="modal-90w"
               centered
              
              show={this.state.show} onHide={this.handleClose2} >
                <Modal.Header closeButton  style={{backgroundColor:'#a02142',color:'white'}} closeVariant='white'>
                <Modal.Title>REPORTE </Modal.Title>
                </Modal.Header>
                <Modal.Body>

                <Grid container spacing={2} >
                <Grid item xs={6}>
                <label>FECHA INICIAL:  </label>
               
                <input 
      type="date" 
      className="form-control" 
      value={this.state.FechaInicial}
      onChange={this.onChangeFechaInicial}
     
     
     
      />

      
      </Grid>
      <Grid item xs={6}>
                <label>FECHA FINAL:  </label>
               
                <input 
      type="date" 
      className="form-control" 
      value={this.state.FechaFinal}
      onChange={this.onChangeFechaFinal}
     
     
     
      />
      
      </Grid>
      </Grid>
              
                </Modal.Body>
                <Modal.Footer>
            
                  { this.state.show2==true ?  [ 
                 <Button onClick={this.handleShow2g} style={{marginTop:20,borderRadius:'40px',fontSize:'16px',backgroundColor:'#E9ECEF',marginRight:10}} className="btn btn-success" >
                 <PictureAsPdfIcon style={{fontSize:'27px',color:'#495057'}} /></Button>,
                 
                 <Button onClick={excelExport} style={{marginTop:20,borderRadius:'40px',fontSize:'16px',backgroundColor:'#E9ECEF',marginRight:10}} >
                 <ExplicitIcon style={{fontSize:'27px',color:'#495057'}} /></Button>,

      <ExcelExport data={this.state.excel} fileName={this.state.FechaFinal+"_SMN-CARTILLAS.xlsx"} ref={_exporter}>
        <ExcelExportColumn field="matricula" title="MATRICULA" headerCellOptions={{
            textAlign: "center"
          }}/>
          <ExcelExportColumn field="clase" title="CLASE" headerCellOptions={{ textAlign: "center" }} />
<ExcelExportColumn field="estatus" title="Estatus" headerCellOptions={{ textAlign: "center" }} />
          <ExcelExportColumn field="nombre" title="NOMBRE" headerCellOptions={{ textAlign: "center" }} />
          <ExcelExportColumn field="ap_paterno" title="APELLIDO PATERNO" headerCellOptions={{ textAlign: "center" }} />
          <ExcelExportColumn field="ap_materno" title="APELLIDO MATERNO" headerCellOptions={{ textAlign: "center" }} />

<ExcelExportColumn field="domicilio" title="DOMICILIO" headerCellOptions={{ textAlign: "center" }} />
<ExcelExportColumn field="estado_civil" title="ESTADO CIVIL" headerCellOptions={{ textAlign: "center" }} />
<ExcelExportColumn field="fecha_nac" title="FECHA DE NACIMIENTO" headerCellOptions={{ textAlign: "center" }} />

        <ExcelExportColumn field="CURP" title="CURP" headerCellOptions={{ textAlign: "center" }} />
        <ExcelExportColumn field="leer_escribir" title="LEER Y ESCRIBIR" headerCellOptions={{ textAlign: "center" }} />
<ExcelExportColumn field="lugar_nac" title="LUGAR DE NACIMIENTO" headerCellOptions={{ textAlign: "center" }} />
<ExcelExportColumn field="ocupacion" title="OCUPACIÓN" headerCellOptions={{ textAlign: "center" }} />
<ExcelExportColumn field="nivel_estudios" title="GRADO DE ESTUDIOS" headerCellOptions={{ textAlign: "center" }} />
<ExcelExportColumn field="remiso" title="REMISO" headerCellOptions={{ textAlign: "center" }} />
<ExcelExportColumn field="FechaValidado" title="FECHA ENTREGA" headerCellOptions={{ textAlign: "center" }} />





      </ExcelExport>
                    ] : null }&nbsp;
               <Button onClick={this.generarreporte}  disabled={this.state.activado} style={{marginTop:20,borderRadius:'40px',fontSize:'16px',backgroundColor:'#E9ECEF',textTransform:'none'}} >
                 GENERAR</Button>
                
                  </Modal.Footer>
              </Modal>
            </>

           
            <>


          
            
      
<Modal 
size="xl"
aria-labelledby="contained-modal-title-vcenter"
dialogClassName="modal-90w"
centered

show={this.state.show22} onHide={this.handleClose22} >
<Modal.Header closeButton  style={{backgroundColor:'#a02142',color:'white'}} closeVariant='white'>
<Modal.Title>Reporte No Registros</Modal.Title>
</Modal.Header>
<Modal.Body>

<Grid container spacing={2} >
<Grid item xs={6}>
<label>FECHA INICIAL:  </label>

<input 
type="date" 
className="form-control" 
value={this.state.FechaInicial}
onChange={this.onChangeFechaInicial}



/>


</Grid>
<Grid item xs={6}>
<label>FECHA FINAL:  </label>

<input 
type="date" 
className="form-control" 
value={this.state.FechaFinal}
onChange={this.onChangeFechaFinal}



/>

</Grid>
</Grid>

</Modal.Body>
<Modal.Footer>

  { this.state.excel22!='' ?  [ 

 
 <Button onClick={excelExport} style={{marginTop:20,borderRadius:'40px',fontSize:'16px',backgroundColor:'#E9ECEF',marginRight:10}} >
 <ExplicitIcon style={{fontSize:'27px',color:'#495057'}} /></Button>,

<ExcelExport data={this.state.excel22} fileName={this.state.FechaFinal+"_smn-no-registros.xlsx"} ref={_exporter}>

<ExcelExportColumn field="nombre" title="Nombre" headerCellOptions={{ textAlign: "center" }} />
<ExcelExportColumn field="ap_paterno" title="APELLIDO PATERNO" headerCellOptions={{ textAlign: "center" }} />
<ExcelExportColumn field="ap_materno" title="APELLIDO MATERNO" headerCellOptions={{ textAlign: "center" }} />

<ExcelExportColumn field="CURP" title="CURP" headerCellOptions={{ textAlign: "center" }} />
<ExcelExportColumn field="telefono" title="Telefono" headerCellOptions={{ textAlign: "center" }} />
<ExcelExportColumn field="domicilio" title="Domicilio" headerCellOptions={{ textAlign: "center" }} />
<ExcelExportColumn field="fecha_reg" title="Fecha Registro" headerCellOptions={{ textAlign: "center" }} />





</ExcelExport>
    ] : null }&nbsp;
<Button onClick={this.generarreporte22}  disabled={this.state.activado} style={{marginTop:20,borderRadius:'40px',fontSize:'16px',backgroundColor:'#E9ECEF',textTransform:'none'}} >
 Generar</Button>

  </Modal.Footer>
</Modal>


<Modal 
size="xl"
aria-labelledby="contained-modal-title-vcenter"
dialogClassName="modal-90w"
centered

show={this.state.show222} onHide={()=>this.setState({show222:false})} >
<Modal.Header closeButton  style={{backgroundColor:'#a02142',color:'white'}} closeVariant='white'>
<Modal.Title>Reporte Constancias Matriculas</Modal.Title>
</Modal.Header>
<Modal.Body>

<Grid container spacing={2} >
<Grid item xs={6}>
<label>FECHA INICIAL:  </label>

<input 
type="date" 
className="form-control" 
value={this.state.FechaInicial}
onChange={this.onChangeFechaInicial}



/>


</Grid>
<Grid item xs={6}>
<label>FECHA FINAL:  </label>

<input 
type="date" 
className="form-control" 
value={this.state.FechaFinal}
onChange={this.onChangeFechaFinal}



/>

</Grid>
</Grid>

</Modal.Body>
<Modal.Footer>

  { this.state.excel222!='' ?  [ 

 
 <Button onClick={excelExport} style={{marginTop:20,borderRadius:'40px',fontSize:'16px',backgroundColor:'#E9ECEF',marginRight:10}} >
 <ExplicitIcon style={{fontSize:'27px',color:'#495057'}} /></Button>,

<ExcelExport data={this.state.excel222} fileName={this.state.FechaFinal+"_smn-constancias-matriculas.xlsx"} ref={_exporter}>
<ExcelExportColumn field="matricula" title="Matricula" headerCellOptions={{
textAlign: "center"
}}/>
<ExcelExportColumn field="clase" title="Clase" headerCellOptions={{ textAlign: "center" }} />
<ExcelExportColumn field="estatus" title="Estatus" headerCellOptions={{ textAlign: "center" }} />
<ExcelExportColumn field="nombre" title="Nombre" headerCellOptions={{ textAlign: "center" }} />
<ExcelExportColumn field="ap_paterno" title="APELLIDO PATERNO" headerCellOptions={{ textAlign: "center" }} />
<ExcelExportColumn field="ap_materno" title="APELLIDO MATERNO" headerCellOptions={{ textAlign: "center" }} />

<ExcelExportColumn field="domicilio" title="Domicilio" headerCellOptions={{ textAlign: "center" }} />
<ExcelExportColumn field="estado_civil" title="ESTADO CIVIL" headerCellOptions={{ textAlign: "center" }} />
<ExcelExportColumn field="fecha_nac" title="FECHA DE NACIMIENTO" headerCellOptions={{ textAlign: "center" }} />

<ExcelExportColumn field="CURP" title="CURP" headerCellOptions={{ textAlign: "center" }} />
<ExcelExportColumn field="leer_escribir" title="Leer y Escribir" headerCellOptions={{ textAlign: "center" }} />
<ExcelExportColumn field="lugar_nac" title="LUGAR DE NACIMIENTO" headerCellOptions={{ textAlign: "center" }} />
<ExcelExportColumn field="ocupacion" title="OCUPACIÓN" headerCellOptions={{ textAlign: "center" }} />
<ExcelExportColumn field="remiso" title="Remiso" headerCellOptions={{ textAlign: "center" }} />
<ExcelExportColumn field="fechaConstancia" title="Fecha Constancia" headerCellOptions={{ textAlign: "center" }} />





</ExcelExport>
    ] : null }&nbsp;
<Button onClick={this.generarreporte222}  disabled={this.state.activado} style={{marginTop:20,borderRadius:'40px',fontSize:'16px',backgroundColor:'#E9ECEF',textTransform:'none'}} >
 Generar</Button>

  </Modal.Footer>
</Modal>
</>
            <>
            
            <Modal 
           size="lg"
           aria-labelledby="contained-modal-title-vcenter"
           dialogClassName="modal-90w"
           centered
          
          show={this.state.show3} onHide={this.handleClose3} >
            <Modal.Header closeButton  style={{backgroundColor:'#a02142',color:'white'}} closeVariant='white'>
            <Modal.Title>No Registro </Modal.Title>
            </Modal.Header>
            <Modal.Body>
            <Grid container spacing={2} style={{padding:'65px'}}>
            <Grid item xs={12}>
                <label style={{color:'#5B6B79',fontSize:'14px'}}>NOMBRE(S) </label>
               
                <input 
                style={{fontSize:'14px',padding:'14px',height:'48.13px',borderRadius:'10px'}}
      type="text" 
      className="form-control" 
      value={this.state.nombre}
      onChange={this.onChangenombre}
     
     
     
      />

      
      </Grid>

      <Grid item xs={6}>
                <label style={{color:'#5B6B79',fontSize:'14px'}}>APELLIDO PATERNO </label>
               
                <input 
                style={{fontSize:'14px',padding:'14px',height:'48.13px',borderRadius:'10px'}}
      type="text" 
      className="form-control" 
      value={this.state.ap_paterno}
      onChange={this.onChangeapellidopaterno}
     
     
     
      />

      
      </Grid>

      <Grid item xs={6}>
                <label style={{color:'#5B6B79',fontSize:'14px'}}>APELLIDO MATERNO </label>
               
                <input 
                style={{fontSize:'14px',padding:'14px',height:'48.13px',borderRadius:'10px'}}
      type="text" 
      className="form-control" 
      value={this.state.ap_materno}
      onChange={this.onChangeapellidomaterno}
     
     
     
      />

      
      </Grid>

      <Grid item xs={9}>
                <label style={{color:'#5B6B79',fontSize:'14px'}}>CURP </label>
               
                <input 
                style={{fontSize:'14px',padding:'14px',height:'48.13px',borderRadius:'10px'}}
      type="text" 
      className="form-control" 
      value={this.state.CURP}
      onChange={this.onChangecurp}
     
     
     
      />

      
      </Grid>

      <Grid item xs={3}>
                <label style={{color:'#5B6B79',fontSize:'14px'}}>Clase </label>
               
                <input 
                style={{fontSize:'14px',padding:'14px',height:'48.13px',borderRadius:'10px'}}
      type="text" 
      className="form-control" 
      value={this.state.clase}
      onChange={this.onChangeclase}
     
     
     
      />

      
      </Grid>

      <Grid item xs={5}>
                <label style={{color:'#5B6B79',fontSize:'14px'}}>Teléfono </label>
               
                <input 
                style={{fontSize:'14px',padding:'14px',height:'48.13px',borderRadius:'10px'}}
      type="text" 
      className="form-control" 
      value={this.state.telefono}
      onChange={this.onChangetelefono}
     
     
     
      />

      
      </Grid>

      <Grid item xs={7}>
                <label style={{color:'#5B6B79',fontSize:'14px'}}>Domicilio </label>
               
                <input 
                style={{fontSize:'14px',padding:'14px',height:'48.13px',borderRadius:'10px'}}
      type="text" 
      className="form-control" 
      value={this.state.domicilio}
      onChange={this.onChangedomicilio}
     
     
     
      />

      
      </Grid>
              </Grid>
          
            </Modal.Body>
            <Modal.Footer>
            <Button variant='secondary' onClick={()=>this.handleClose3()}>CANCELAR</Button>
     <Button style={{backgroundColor:'#A02142',color:'white'}} variant='success' onClick={()=>{

let obj={


  ap_paterno:this.state.ap_paterno,
  ap_materno:this.state.ap_materno,
  nombre:this.state.nombre,
  CURP:this.state.CURP,
  clase:this.state.clase,
  domicilio:this.state.domicilio,
  telefono:this.state.telefono,

}

console.log('OBJ NO REGISTRO');
console.log(obj);

POSTNoregistro(obj).then(response => {
     
  console.log("Aqui ese supone q se registro")
  console.log(response);
 // window.location.reload();
 if(response!="error en el servidor."){
 alert("Registro Guardado!");
 this.setState({
  ap_paterno:'',
  ap_materno:'',
  nombre:'',
  CURP:'',
  clase:'',
  domicilio:'',
  telefono:'',

 })
this.props.onR()
}
}).catch(err => console.log(err)); 


     }}>REGISTRAR</Button>
     </Modal.Footer>
          </Modal>
            
      
            <Modal 
           size="xl"
           aria-labelledby="contained-modal-title-vcenter"
           dialogClassName="modal-90w"
           centered
          
          show={this.state.show2g} onHide={this.handleClose2g} >
            <Modal.Header closeButton  style={{backgroundColor:'#a02142',color:'white'}} closeVariant='white'>
            <Modal.Title>REPORTE </Modal.Title>
            </Modal.Header>
            <Modal.Body>
            {this.state.show2g==true ? [<div style={{height:700}}><PDFViewer width={'100%'} height={'100%'} showToolbar={true}>
    {this.pdf(this.state.excel)}
  </PDFViewer></div>,<PDFDownloadLink document={this.pdf(this.state.excel)} fileName={"REPORTE-SMN-CARTILLAS"+".pdf"} >
      {({ blob, url, loading, error }) => (loading ? 'Loading document...' :  <Button  variant="outlined" color="primary" >Descargar</Button>)}
    </PDFDownloadLink>]: null}  
          
            </Modal.Body>
           
          </Modal>


          <Modal 
           size="xl"
           aria-labelledby="contained-modal-title-vcenter"
           dialogClassName="modal-90w"
           centered
          
          show={this.state.show2g222} onHide={()=>this.setState({show2g222:false})} >
            <Modal.Header closeButton  style={{backgroundColor:'#a02142',color:'white'}} closeVariant='white'>
            <Modal.Title>Reporte Constancias Matriculas </Modal.Title>
            </Modal.Header>
            <Modal.Body>
            {this.state.show2g222==true ? [<div style={{height:700}}><PDFViewer width={'100%'} height={'100%'} showToolbar={true}>
    {this.pdf222(this.state.excel222)}
  </PDFViewer></div>,<PDFDownloadLink document={this.pdf222(this.state.excel222)} fileName={"reporte-smn-cartillas"+".pdf"} >
      {({ blob, url, loading, error }) => (loading ? 'Loading document...' :  <Button  variant="outlined" color="primary" >Descargar</Button>)}
    </PDFDownloadLink>]: null}  
          
            </Modal.Body>
           
          </Modal>

          <Modal 
           size="xl"
           aria-labelledby="contained-modal-title-vcenter"
           dialogClassName="modal-90w"
           centered
          
          show={this.state.show2g22} onHide={()=>this.setState({show2g22:false})} >
            <Modal.Header closeButton  style={{backgroundColor:'#a02142',color:'white'}} closeVariant='white'>
            <Modal.Title>Reporte No Registrados </Modal.Title>
            </Modal.Header>
            <Modal.Body>
            {this.state.show2g22==true ? [<div style={{height:700}}><PDFViewer width={'100%'} height={'100%'} showToolbar={true}>
    {this.pdf22(this.state.excel22)}
  </PDFViewer></div>,<PDFDownloadLink document={this.pdf22(this.state.excel22)} fileName={"reporte-smn-cartillas"+".pdf"} >
      {({ blob, url, loading, error }) => (loading ? 'Loading document...' :  <Button  variant="outlined" color="primary" >Descargar</Button>)}
    </PDFDownloadLink>]: null}  
          
            </Modal.Body>
           
          </Modal>
        </>

      
    
        </div>
      );
    }
  }



  const styles = StyleSheet.create({
    page: {
      flexDirection: 'row',
      backgroundColor: '#E4E4E4',
    },
    section: {
      margin: 10,
      padding: 10,
      flexGrow: 1,
    },
    header: {
      backgroundColor: '#a5a4a4',
      color: '#FFFFFF',
      padding: 7,
      fontSize: 10,
      fontWeight: 'bold',
      textAlign: 'center',
    },
    cell: {
     width: '6.66%', // Ancho fijo para cada celda
      padding: 5,
      textAlign: 'center',
      border: '1px solid #000000',
      wordWrap: 'break-word', // Ajuste de texto
      fontSize: 6, // Tamaño de la letra reducido
    },
    cell2: {
      width: '6.66%', // Ancho fijo para cada celda
      padding: 5,
      textAlign: 'center',
      fontWeight:'bold',
      fontFamily:'Helvetica-Bold',
      border: '1px solid #000000',
      wordWrap: 'break-word', // Ajuste de texto
      fontSize: 6, // Tamaño de la letra reducido
    },
    cell22g: {
      width: '12.5%', // Ancho fijo para cada celda
       padding: 5,
       textAlign: 'center',
       border: '1px solid #000000',
       wordWrap: 'break-word', // Ajuste de texto
       fontSize: 6, // Tamaño de la letra reducido
     },
    cell22: {
      width: '12.5%', // Ancho fijo para cada celda
      padding: 5,
      textAlign: 'center',
      fontWeight:'bold',
      fontFamily:'Helvetica-Bold',
      border: '1px solid #000000',
      wordWrap: 'break-word', // Ajuste de texto
      fontSize: 6, // Tamaño de la letra reducido
    },
  });
  